(() => {
  const CART_ORIGIN_KEY = 'jolCartOrigin';
  const CART_ENTER_KEY = 'jolCartEnterMode';
  const DETAILS_ORIGIN_KEY = 'jolFullDetailsOrigin';
  const html = document.documentElement;
  const reducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const here = () => `${location.pathname}${location.search}`;

  const readJSON = (key) => {
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) { return null; }
  };
  const writeJSON = (key, value) => {
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
  };

  const markCartOrigin = (mode) => {
    writeJSON(CART_ORIGIN_KEY, { url: here(), mode, time: Date.now() });
    try { sessionStorage.setItem(CART_ENTER_KEY, mode); } catch (_) {}
  };

  const addTransitionType = (link, type) => {
    link?.setAttribute('data-view-transition-triggered', '');
    link?.setAttribute('data-view-transition-type', type);
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) return;

    const catalogSlide = event.target.closest?.('[data-jol-catalog-slide][href]');
    if (catalogSlide) {
      try { sessionStorage.setItem('jolCatalogEnter', '1'); } catch (_) {}
      addTransitionType(catalogSlide, 'jol-catalog-forward');
      return;
    }

    const bagCheckout = event.target.closest?.('.jol-cart-preview__checkout[href]');
    if (bagCheckout) {
      // Keep the existing bag tab at its normal width. The cart page itself
      // handles the transition and slides in from the right, matching PDP checkout.
      markCartOrigin('bag');
      addTransitionType(bagCheckout, 'jol-cart-bag');
      return;
    }

    const productCheckout = event.target.closest?.('.jol-product-cart-link[href]');
    if (productCheckout) {
      markCartOrigin('product');
      addTransitionType(productCheckout, 'jol-cart-product');
      return;
    }

    const fullDetails = event.target.closest?.('[data-jol-qv-details][href]');
    if (fullDetails) {
      writeJSON(DETAILS_ORIGIN_KEY, { url: here(), time: Date.now() });
    }
  }, true);

  const waitFor = (selector, timeout = 1000) => new Promise((resolve) => {
    const existing = document.querySelector(selector);
    if (existing) { resolve(existing); return; }
    const observer = new MutationObserver(() => {
      const found = document.querySelector(selector);
      if (!found) return;
      observer.disconnect();
      resolve(found);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => { observer.disconnect(); resolve(document.querySelector(selector)); }, timeout);
  });

  const restoreBagAfterCartBack = async () => {
    // V176: browser Back uses the native page restore. If checkout began from the
    // existing bag tab, quietly restore that tab without a reverse page animation.
    let overlay = document.querySelector('[data-jol-cart-overlay]');
    if (!overlay?.classList.contains('is-open')) {
      const trigger = [...document.querySelectorAll('[data-jol-cart-trigger]')][0];
      trigger?.click();
      await waitFor('[data-jol-cart-overlay].is-open', 1200);
    }
    try { sessionStorage.removeItem(CART_ORIGIN_KEY); } catch (_) {}
  };

  const applyBackState = (event) => {
    const nav = performance.getEntriesByType?.('navigation')?.[0];
    const isBackForward = Boolean(event?.persisted || nav?.type === 'back_forward');
    if (!isBackForward) return;
    const current = here();

    const cartOrigin = readJSON(CART_ORIGIN_KEY);
    if (cartOrigin?.url === current && Date.now() - Number(cartOrigin.time || 0) < 30 * 60 * 1000) {
      if (cartOrigin.mode === 'bag') requestAnimationFrame(() => restoreBagAfterCartBack());
      else {
        try { sessionStorage.removeItem(CART_ORIGIN_KEY); } catch (_) {}
      }
    }

    const detailsOrigin = readJSON(DETAILS_ORIGIN_KEY);
    if (detailsOrigin?.url === current && Date.now() - Number(detailsOrigin.time || 0) < 30 * 60 * 1000) {
      // No reverse slide on Back; native restoration plus the brown fade mask is smoother.
      try { sessionStorage.removeItem(DETAILS_ORIGIN_KEY); } catch (_) {}
    }
  };

  const cleanupForwardClasses = () => {
    ['jol-cart-enter-product','jol-cart-enter-bag','jol-catalog-enter'].forEach((className) => {
      if (!html.classList.contains(className)) return;
      const wrapper = document.querySelector('.page-wrapper');
      const done = () => html.classList.remove(className);
      if (!wrapper || reducedMotion()) { done(); return; }
      wrapper.addEventListener('animationend', done, { once: true });
      window.setTimeout(done, 900);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanupForwardClasses, { once: true });
  } else {
    cleanupForwardClasses();
  }
  window.addEventListener('pageshow', applyBackState);
})();
